enum DonationRecurringPeriod {
  None = 'None',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Annually = 'Annually',
}
export default DonationRecurringPeriod;
